import React, { useCallback } from 'react'
import { FilterOptionType, useProductListPage } from 'lib/modules/catalog'
import { useIsMobile } from 'hooks/responsive'
import { Filter } from './components/Filter'
import { Container, FilterButtonsWrapper } from './styled'
import { ReactComponent as RemoveSvg } from 'resources/svg/icons/trash.svg'
import { ReactComponent as CloseSvg } from 'resources/svg/icons/filter-close.svg'

interface Props {
  categoryId?: number
  onFilterChange?: () => void
  onClearFiltersPress?: () => void
}

const CATEGORY_FILTER_NAME = 'Category'

export const LayeredNav = ({ categoryId, onFilterChange, onClearFiltersPress }: Props) => {
  const isMobile = useIsMobile()
  const { isFetching, handleFilterChange, layeredNav } = useProductListPage({
    categoryId,
    onFilterChange,
    withLayeredNav: true
  })

  const selectedFilterOptions = layeredNav?.filterOptions.map((item) => item.selected).filter(val => val != null).flat()

  const hasFiltersSelected = selectedFilterOptions && selectedFilterOptions.length > 0

  return (
    <Container
      isFetching={isFetching}
    >
      {!isMobile && !hasFiltersSelected && (
        <h3>Filter</h3>
      )}

      {hasFiltersSelected && (
        <FilterButtonsWrapper>
          <h4>Your selections</h4>
          {selectedFilterOptions?.map(selectedOption => (
            <SelectedFilterItem key={selectedOption?.requestVar} item={selectedOption} onRemovePress={handleFilterChange} />)
          )}

          <button onClick={onClearFiltersPress} className='remove'>
            <RemoveSvg /> Clear Filters
          </button>
        </FilterButtonsWrapper>
      )}

      <div>
        {layeredNav?.appliedFilters && (
          <ul>
            {layeredNav?.filterOptions?.map(item => {
              if (item.name === CATEGORY_FILTER_NAME) return null
              return (
                <Filter
                  key={item.code}
                  isFetching={isFetching}
                  filterOptions={item}
                  handleFilterChange={handleFilterChange}
                />
              )
            })}
          </ul>
        )}
      </div>
    </Container>
  )
}

interface SelectedFilterProps {
  item: FilterOptionType | null
  onRemovePress: (param: any) => void
}

const SelectedFilterItem = ({ item, onRemovePress }: SelectedFilterProps) => {
  const handleRemovePress = useCallback(() => onRemovePress({
    requestVar: item?.requestVar,
    value: [item?.value],
    conf: {
      multiple: true
    }
  }), [item, onRemovePress])

  return (
    <button className='filter' type='button'>
      <span>{item?.label}</span>
      <span onClick={handleRemovePress}><CloseSvg /></span>
    </button>)
}
